// Apolo IDE — useScheduledTasks hook (Sprint v6 B3).

import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../lib/api.js';
import { dispatchScheduledTask } from '../lib/scheduledTaskDispatch.js';

export function useScheduledTasks() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await apiFetch('/api/code-ide/schedule');
    setLoading(false);
    if (!res.ok) { setError(res.error || 'Falha ao carregar schedules'); return; }
    setError(null);
    const loaded = Array.isArray(res.data?.tasks) ? res.data.tasks : [];
    setTasks(loaded);
    return loaded;
  }, []);

  useEffect(() => { load(); }, [load]);

  async function create(fields) {
    const res = await apiFetch('/api/code-ide/schedule', {
      method: 'POST',
      body: JSON.stringify(fields),
    });
    if (res.ok) load();
    return res;
  }

  async function update(id, fields) {
    const res = await apiFetch(`/api/code-ide/schedule/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(fields),
    });
    if (res.ok) load();
    return res;
  }

  async function remove(id) {
    const res = await apiFetch(`/api/code-ide/schedule/${id}`, { method: 'DELETE' });
    if (res.ok) load();
    return res;
  }

  async function runNow(id) {
    const res = await dispatchScheduledTask(tasks.find((task) => task.id === id));
    const failed = !res.ok || res.data?.status === 'failed';
    const message = failed ? res.error || res.data?.error || 'Tarefa falhou' : res.data?.status === 'queued' ? 'Tarefa na fila. A execução começa no próximo minuto; acompanhe o histórico.' : 'Tarefa concluída';
    setError(failed ? message : null);
    window.dispatchEvent(new CustomEvent('apolo:toast', { detail: { kind: failed ? 'error' : 'success', message } }));
    if (res.ok) load();
    return res;
  }

  async function toggle(task) {
    const status = task.status === 'enabled' ? 'paused' : 'enabled';
    return update(task.id, { status });
  }

  return { tasks, loading, error, load, create, update, remove, runNow, toggle };
}
